// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2grrq","approved":"Status_approved__18Ywr","rejected":"Status_rejected__LnsMJ","expired":"Status_expired__2kfeE","label":"Status_label__1HbOX"};